/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import {
  EnvironmentVariableInput,
  EnvironmentVariableInput$Outbound,
  EnvironmentVariableInput$outboundSchema,
} from "./environmentvariableinput.js";

export type V1EnvironmentsSetEnvironmentVariablesRequestBody = {
  /**
   * Identifies a resource by either its unique ID or its slug.
   *
   * @remarks
   * Accepts a prefixed ID (such as 'proj_' or 'app_') or a slug.
   */
  project: string;
  /**
   * Identifies a resource by either its unique ID or its slug.
   *
   * @remarks
   * Accepts a prefixed ID (such as 'proj_' or 'app_') or a slug.
   */
  app: string;
  /**
   * Identifies a resource by either its unique ID or its slug.
   *
   * @remarks
   * Accepts a prefixed ID (such as 'proj_' or 'app_') or a slug.
   */
  environment: string;
  /**
   * The variables to upsert. Each entry is created if its key is new or fully
   *
   * @remarks
   * overwritten if the key already exists. Existing variables whose keys are
   * not in this list are left untouched, unless `prune` is true.
   *
   * Each entry is written exactly as sent, never merged with the current
   * state. Only `value` is required; omitted optional fields (`kind`,
   * `description`) fall back to their defaults rather than any previous value,
   * so overwriting a variable without a `description` clears it.
   *
   * Each key may appear at most once; a duplicate key is rejected with a 400.
   * The whole operation is atomic: if any part fails the environment is left
   * unchanged. All values are encrypted at rest. Limited to 50 variables per
   * request.
   */
  variables: Array<EnvironmentVariableInput>;
  /**
   * Optional. Defaults to false. When false, the variables above are upserted
   *
   * @remarks
   * and any existing variable not in the list is kept. When true, this becomes
   * a full replace: after upserting, every variable not in the list is deleted.
   * Combined with an empty `variables` list, `prune: true` resets the entire
   * environment by deleting every variable.
   */
  prune?: boolean | undefined;
};

/** @internal */
export type V1EnvironmentsSetEnvironmentVariablesRequestBody$Outbound = {
  project: string;
  app: string;
  environment: string;
  variables: Array<EnvironmentVariableInput$Outbound>;
  prune: boolean;
};

/** @internal */
export const V1EnvironmentsSetEnvironmentVariablesRequestBody$outboundSchema:
  z.ZodType<
    V1EnvironmentsSetEnvironmentVariablesRequestBody$Outbound,
    z.ZodTypeDef,
    V1EnvironmentsSetEnvironmentVariablesRequestBody
  > = z.object({
    project: z.string(),
    app: z.string(),
    environment: z.string(),
    variables: z.array(EnvironmentVariableInput$outboundSchema),
    prune: z.boolean().default(false),
  });

export function v1EnvironmentsSetEnvironmentVariablesRequestBodyToJSON(
  v1EnvironmentsSetEnvironmentVariablesRequestBody:
    V1EnvironmentsSetEnvironmentVariablesRequestBody,
): string {
  return JSON.stringify(
    V1EnvironmentsSetEnvironmentVariablesRequestBody$outboundSchema.parse(
      v1EnvironmentsSetEnvironmentVariablesRequestBody,
    ),
  );
}
